module.exports = __webpack_public_path__ + "media/r_schweinepriester.1c1dd4c2.mp3";